import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App/App";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.Suspense fallback={<p>Loading...</p>}>
		<div className="font-Neue">
			<App />
		</div>
	</React.Suspense>
);
